<div class="space-y-2">
  <h4 class="text-xs font-medium-variant">Status</h4>
  <div class="flex items-center gap-2">
    <div
      class="w-2 h-2 rounded-full"
      [class.bg-yellow-500]="loading()"
      [class.bg-gray-400]="!loading()"
    ></div>
    <span class="text-xs">Loading: {{ loading() }}</span>
  </div>
  <div class="flex items-center gap-2">
    <div
      class="w-2 h-2 rounded-full"
      [class.bg-success]="initialized()"
      [class.bg-info]="!initialized()"
    ></div>
    <span class="text-xs">Initialized: {{ initialized() }}</span>
  </div>

  <div class="flex items-center gap-2">
    <div
      class="w-2 h-2 rounded-full"
      [class.bg-success]="isReady()"
      [class.bg-info]="!isReady()"
    ></div>
    <span class="text-xs">Ready: {{ isReady() }}</span>
  </div>

  <div class="flex items-center gap-2">
    <div
      class="w-2 h-2 rounded-full"
      [class.bg-success]="hasData()"
      [class.bg-gray-400]="!hasData()"
    ></div>
    <span class="text-xs">Has Data: {{ hasData() }}</span>
  </div>

  @if (hasActiveTeam()) {
  <div class="flex items-center gap-2">
    <div
      class="w-2 h-2 rounded-full"
      [class.bg-info]="hasActiveTeam()"
      [class.bg-gray-400]="!hasActiveTeam()"
    ></div>
    <span class="text-xs">Active Team: {{ hasActiveTeam() }}</span>
  </div>
  }

  @if (error()) {
  <div class="p-2 bg-error-container text-on-error-container rounded text-xs">
    <strong>Error:</strong> {{ error() }}
  </div>
  }
</div>
